import { useAtomValue } from 'jotai';

import { userAccountAtom } from '@/state';

/** The signed-in user's account, kept live by `useUserAccountListener` in the protected routes. */
export const useUserAccount = () => useAtomValue(userAccountAtom);
